import React from 'react';
import TypeGroupSection from './TypeGroupSection';

const insulationOptions = [
  { value: 'EPS', label: 'EPS' },
  { label: 'XPS', value: 'XPS' },
  { label: 'Fiberglass', value: 'Fiberglass' },
  { label: 'Cellulose', value: 'Cellulose' },
  { label: 'Mineral Wool', value: 'Mineral Wool' },
  { label: 'Other', value: 'Other' },
];

const wallTypeOptions = [
  'Interior Load Bearing Double-Stud',
  'Exterior Load Bearing Double-Stud',
  'Framing with Continuous Insulation',
  'All Insulation within Framing',
  'Exterior Continuous Insulation Only',
  'Insulated Concrete Form (ICF)',
  'Structurally Insulated Panel (SIP)',
  'Other',
];

// Verified against source: wall group 1's Wall Type select has a blank leading option;
// groups 2 and 3 do not (source never gated this by editability/index in a uniform way —
// it's just how the markup was hand-copied). Preserved explicitly, not normalized.
const wallConfig = {
  gatingField: 'number_of_wall_types',
  maxCount: 3,
  fields: [
    {
      kind: 'select',
      nameTemplate: 'wall_type_{n}',
      label: 'Wall Type',
      options: wallTypeOptions,
      emptyOption: (n) => n === 1,
      disabledFallback: 'text',
    },
    { kind: 'decimal', nameTemplate: 'wall_thermal_performance_{n}', label: 'Wall R-Value', unit: 'hr⋅ft²⋅°F/BTU' },
    { kind: 'multiselect', nameTemplate: 'wall_insulation_type_{n}', label: 'Wall Insulation Type', options: insulationOptions },
  ],
};

const floorTypeOptions = ['Slab on Grade', 'Basement Slab', 'Crawlspace Floor', 'Overhang Floor', 'Other'];

// Floor R-Value is deliberately `kind: 'text'`, not `'decimal'` like Wall/Roof R-Value —
// the source never wired it to `ValidatedDecimalInput`/`onValidityChange`, so it does not
// participate in the Save-disable (`invalidFields`) gate today. Preserved as-is.
const floorConfig = {
  gatingField: 'number_of_floor_types',
  maxCount: 3,
  fields: [
    {
      kind: 'select',
      nameTemplate: 'floor_type_{n}',
      label: 'Floor Type',
      options: floorTypeOptions,
      emptyOption: true,
      editValueTemplate: 'wall_type_{n}',
      disabledFallback: 'text',
    },
    { kind: 'text', nameTemplate: 'floor_thermal_performance_{n}', label: 'Floor R-Value', unit: 'hr⋅ft²⋅°F/BTU' },
    { kind: 'multiselect', nameTemplate: 'floor_insulation_type_{n}', label: 'Floor Insulation Type', options: insulationOptions },
  ],
};

const roofTypeOptions = ['Vented Above Deck', 'Vented Below Deck', 'Unvented Roof', 'Other'];

const roofConfig = {
  gatingField: 'number_of_roof_types',
  maxCount: 3,
  fields: [
    { kind: 'select', nameTemplate: 'roof_type_{n}', label: 'Roof Type', options: roofTypeOptions, emptyOption: true, disabledFallback: 'text' },
    { kind: 'decimal', nameTemplate: 'roof_thermal_performance_{n}', label: 'Roof R-Value', unit: 'hr⋅ft²⋅°F/BTU' },
    { kind: 'multiselect', nameTemplate: 'roof_insulation_type_{n}', label: 'Roof Insulation Type', options: insulationOptions },
  ],
};

export default function WallFloorRoofTab({ project, editable, handleInputChange, handleSelectChange, handleFieldValidityChange }) {
  const ctx = { project, editable, handleInputChange, handleSelectChange, handleFieldValidityChange };
  return (
    <table className='project-detail-table'>
      <tbody>
        <tr>
          <td>Number of Wall Types</td>
          <td>
            {editable === true ? (
              <select
                name='number_of_wall_types'
                onChange={handleInputChange}
                className='edit-input'
                defaultValue={project.number_of_wall_types}
              >
                <option value=''></option>
                <option value='1'>1</option>
                <option value='2'>2</option>
                <option value='3'>3</option>
              </select>
            ) : (
              project.number_of_wall_types
            )}
          </td>
        </tr>
        <TypeGroupSection {...wallConfig} {...ctx} />
        <tr>
          <td>Number of Floor Types</td>
          <td>
            {editable === true ? (
              <select
                name='number_of_floor_types'
                onChange={handleInputChange}
                className='edit-input'
                defaultValue={project.number_of_floor_types}
              >
                <option value=''></option>
                <option value='1'>1</option>
                <option value='2'>2</option>
                <option value='3'>3</option>
              </select>
            ) : (
              project.number_of_floor_types
            )}
          </td>
        </tr>
        <TypeGroupSection {...floorConfig} {...ctx} />
        <tr>
          <td>Number of Roof Types</td>
          <td>
            {editable === true ? (
              <select
                name='number_of_roof_types'
                onChange={handleInputChange}
                className='edit-input'
                defaultValue={project.number_of_roof_types}
              >
                <option value=''></option>
                <option value='1'>1</option>
                <option value='2'>2</option>
                <option value='3'>3</option>
              </select>
            ) : (
              project.number_of_roof_types
            )}
          </td>
        </tr>
        <TypeGroupSection {...roofConfig} {...ctx} />
      </tbody>
    </table>
  );
}
